import React, {Fragment} from 'react';
import {Link} from 'react-router-dom';
import ContentLoader from "react-content-loader"

import createLink from "../../../../../libs/createLink";

import Avatar from '../../../Avatar';

import Icon from '../../../Icon';
import Alert from '../../../Alert';
import Report from '../../../Report';
import Dropdown from "../../../Dropdown";
import ViewMore from "../../../ViewMore";
import {Can} from "../../../../../ability-context";
import Modal from "../../../Modal";
import DateSince from "../../../Date";
import LikeText from "../../../Like/LikeComment";
import {isNoFollowProfil} from "../../../../../libs/helper";
import EncourageSignup from "../../../../components2/encourageSignup/EncourageSignup";
import Reader from "../../../../../libs/lexical/Reader";


class SubComment extends React.Component {
    constructor(props) {
        super(props);
        this.initialSubCommentAnswer = {
            owner: {}
        };
        this.state = {
            isHidden: false,
            height: 0,
            confirm: false,
            edit: false,
            toggleAnswer: false,
            subCommentAnswer: this.initialSubCommentAnswer,
        };
        this.handleDelete = this.handleDelete.bind(this);
        this.updateSubComment = this.updateSubComment.bind(this);
        this.toggleSubComment = this.toggleSubComment.bind(this);
        this.handleReport = this.handleReport.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        // this.editorRef = React.createRef();
    }

    // componentDidUpdate(prevProps, prevState, snapshot) {
    //     if(prevProps.contentRaw !== this.props.contentRaw){
    //         this.editorRef.current.updateContent(this.props.contentRaw);
    //     }
    // }


    handleDelete() {
        this.props.deleteSubComment(this.props._id);
        this.setState({confirm: false});
    }

    updateSubComment(id, value) {
        this.props.updateSubComment(id, value);
        this.setState({edit: false});
    }

    toggleSubComment() {
        this.setState({toggleSubComment: !this.state.toggleSubComment});
    }

    handleReport(message){
        this.props.handleReport(this.props._id, message)
    }

    handleIfCanAnswer(owner){
        if(this.props.currentUser && this.props.currentUser._id){
            this.handleSubCommentAnswer(owner);
            this.setState({toggleAnswer: !this.state.toggleAnswer})
        } else {
            this.setState({toggleSignIn: !this.state.toggleSignIn})
        }
    }

    handleSubCommentAnswer(ownerOfSubComment){
        this.setState({subCommentAnswer: {
                owner: ownerOfSubComment,
            }});
    }

    handleSubmit(contentRaw){
        this.props.handleSubmit(contentRaw);
        this.setState({toggleAnswer: false})
    }


    render() {
        let heightLimit = 16 * 8;
        let relLinkProfil = {};
        if(this.props.commentsInitialized){
            relLinkProfil = isNoFollowProfil(this.props.owner) ? { rel: "nofollow" } : {};
        }
        return !this.props.commentsInitialized ? (
            <div className={`comment sub-comment`}>
                <ContentLoader
                    height={50}
                    width={200}
                    speed={2}
                    ariaLabel={false}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="80" rx="3" ry="3" width="350" height="6.4"/>
                    <rect x="0" y="100" rx="3" ry="3" width="380" height="6.4"/>
                    <rect x="0" y="120" rx="3" ry="3" width="201" height="6.4"/>
                    <circle cx="11.86" cy="17.97" r="8.86"/>
                    <rect x="32.78" y="6.61" rx="10" ry="10" width="157.94" height="35.47"/>
                </ContentLoader>
            </div>
        ) : (
            <Fragment>
                <div
                    className={`comment ${(!this.props.isApproved && typeof (this.props.isApproved) !== 'undefined') ? 'pending' : ''}`}>
                    <div className={"row"}>
                        {this.props.owner._id ? (
                            <Link to={createLink("userProfile", this.props.owner)} {...relLinkProfil}>
                                <Avatar avatar={this.props.owner.profile.avatar} gender={this.props.owner.profile.gender}/>
                            </Link>
                        ) : (
                            <Avatar gender="guest"/>
                        )}
                        <div className="wrapper-comment">
                            <div className={"comment-with-options"}>
                                <div className="infos">
                                    <div
                                        className={`comment-content`}>
                                        <ViewMore limit={heightLimit} kind={"comment"}>
                                            {this.props.owner._id ? (
                                                <Link className="username"
                                                      to={createLink("userProfile", this.props.owner)} {...relLinkProfil}>{this.props.owner.username}</Link>
                                            ) : (
                                                <span
                                                    className="username unknown mr-8">{this.props.authorName || "*Utilisateur Supprimé*"}</span>
                                            )}
                                            <div className="comment-editor-style">
                                                <Reader text={this.props.text} meta={{
                                                    mention : this.props.mentions
                                                }}/>
                                            </div>
                                            {/*<DraftContentReader contentRaw={this.props.contentRaw} ref={this.editorRef}/>*/}
                                        </ViewMore>
                                    </div>
                                </div>
                                <Can action={"moderation"} subject={this.props} modelName="Comment">
                                    <div className="comment-options">
                                        <Dropdown align="right" closeOnClick={true} activableComponent={(
                                            <Icon type="horizontal-dots"/>
                                        )}>
                                            <div className="dropdown-menu">
                                                <Can action={"delete"} subject={this.props} modelName="Comment">
                                                    <li className="menu-item trash"
                                                        onClick={() => this.setState({confirm: true})}><Icon
                                                        type="trash"/> Supprimer
                                                    </li>
                                                </Can>
                                                <Can action={"update"} subject={this.props} modelName="Comment">
                                                    <li className="menu-item edit"
                                                        onClick={() => this.props.handleEdit({
                                                            parentCommentId : this.props.commentId,
                                                            parentId : this.props.parentId,
                                                            commentId : this.props._id,
                                                            text : this.props.text,
                                                            mentions : this.props.mentions,
                                                            commentType : this.props.subCommentType
                                                        })}><Icon
                                                        type="pencil-square"/> Editer
                                                    </li>
                                                </Can>
                                                <Can action={"report"} subject={this.props} modelName="Comment">
                                                    <li className={"menu-item"}><Icon type="report"/>
                                                        <Report _id={this.props._id}
                                                                kind={"comments"}
                                                                handleReport={this.handleReport}
                                                                title="le commentaire"/>
                                                    </li>
                                                </Can>
                                            </div>
                                        </Dropdown>
                                    </div>
                                </Can>
                            </div>
                            <div className="wrapper-link">
                                {(!this.props.isApproved && typeof (this.props.isApproved) !== 'undefined') && (
                                    <div className="waiting-mod">En attente de modération</div>)}
                                {this.props.isApproved && (
                                    <div className="btn-group">
                                        {this.props._id &&
                                        <LikeText likeType={this.props.subCommentType}
                                                  commentId={this.props.commentId}
                                                  subCommentId={this.props._id}
                                                  isLiked={this.props.isLiked}
                                                  value={this.props.count && this.props.count.like}
                                                  parentId={this.props.parentId}/>} ·
                                        <div className="answer"
                                             onClick={() => this.props.handleSubCommentAnswer(this.props.owner)}>répondre</div>
                                    </div>
                                )}
                                <EncourageSignup toggle={this.state.toggleSignIn} handleClose={() => this.setState({toggleSignIn: false})} />
                                &nbsp;
                                <span className="comment-date text small medium-grey ml-4">
                                ·&nbsp;
                                    <DateSince
                                        className={"ml-4"}
                                        format={"DD/MM/YYYY"}
                                        date={this.props.createdAt}
                                        prefix={false}
                                        currentFormat={true}
                                    />
                            </span>
                                {/*<span className="text small medium-grey px-4">{this.props.createdAt !== this.props.updatedAt && "(modifié)"}</span>*/}
                                <Modal toggle={this.state.confirm} handleClose={() => this.setState({confirm: false})}>
                                    <Alert
                                        text="Voulez vous vraiment supprimer ce commentaire ?"
                                        handleClose={() => this.setState({confirm: false})}
                                        handleDelete={this.handleDelete}
                                    />
                                </Modal>
                            </div>
                        </div>
                    </div>
                </div>
                {/*{this.state.toggleAnswer && (
                    <InputPost sendBtnIcon={true}
                               handleSubmit={this.handleSubmit}
                               emoji={true}
                               editorStyle={"add-comment"}
                               subCommentAnswer={this.state.subCommentAnswer}
                               loading={this.props.subCommentsSubmitting}
                               enterSubmit={true}
                               canOptions={{
                                   subject: this.props,
                                   modelName: "Comment",
                                   action: "create",
                                   passThrough: true
                               }}
                    />
                )}*/}
            </Fragment>
        )
    }
}

export default SubComment;
